const ALLOCATION_TOTAL = 100;
const ALLOCATION_TOLERANCE = 0.01;

export const isAllocationTotalValid = (total: number) =>
	Math.abs(total - ALLOCATION_TOTAL) <= ALLOCATION_TOLERANCE;

export const isAllocationTotalWithinLimit = (total: number) =>
	total <= ALLOCATION_TOTAL + ALLOCATION_TOLERANCE;

const clampPercent = (value: number | null) =>
	Math.min(ALLOCATION_TOTAL, Math.max(0, value ?? 0));

const round = (value: number) => Math.round(value * 100) / 100;

export const getDrainOrder = (
	keys: string[],
	editedKey: string,
	editOrder: string[],
): string[] =>
	[...keys]
		.reverse()
		.filter((key) => key !== editedKey)
		.sort((left, right) => editOrder.indexOf(left) - editOrder.indexOf(right));

export const applyPercentEdit = (
	percentByKey: Record<string, number | null>,
	keys: string[],
	editedKey: string,
	value: number | null,
	editOrder: string[],
): Record<string, number | null> => {
	const next: Record<string, number | null> = {
		...percentByKey,
		[editedKey]: value,
	};

	const drainOrder = getDrainOrder(keys, editedKey, editOrder);
	if (drainOrder.length === 0) return next;

	let excess = round(
		drainOrder.reduce(
			(sum, key) => sum + clampPercent(percentByKey[key]),
			clampPercent(value),
		) - ALLOCATION_TOTAL,
	);
	if (excess <= 0) return next;

	for (const key of drainOrder) {
		if (excess <= 0) break;
		const current = clampPercent(percentByKey[key]);
		const taken = Math.min(current, excess);
		next[key] = round(current - taken);
		excess = round(excess - taken);
	}

	return next;
};
